<template>
  <div
    :ref="name + 'ref'"
    :id="'inav' + name.norm()"
    style="max-height: -webkit-fill-height; overflow: visible"
    :key="name + $store.state.counter"
    :class="
      'wrap inav' + name.norm() + ' ' + $store.state.app.basics.menus[name].class ||
      'flex around scroll-y'
    "
    v-if="$store.state.app.basics.menus[name]"
  >
    <span
      :id="'inav' + name.norm() + item.name.norm()"
      :class="'inav' + name.norm() + item.name.norm() + ' ' + item.class"
      v-for="(item, itemkey) in computedmenu"
      :key="itemkey"
    >
      <router-link
        v-if="item.type == 'link' && item.to[0] == '/'"
        :to="item.to"
        class="flex align-center"
      >
        <i
          v-if="item.display && item.display.indexOf('icon') > -1"
          :class="item.icon"
          class="m4"
        />
        <img
          class="m4"
          v-if="item.display && item.display.indexOf('image') > -1"
          :src="item.image"
          style="object-fit: contain"
        />
        {{
          !item.display || item.display.indexOf("text") > -1 ? item.name : ""
        }}
      </router-link>
      <a
        class="flex align-center"
        v-if="item.type == 'link' && item.to[0] !== '/'"
        :href="item.to.indexOf('http') === 0 ? item.to : 'https://' + item.to"
        target="_blank"
      >
        <i
          v-if="item.display && item.display.indexOf('icon') > -1"
          :class="item.icon"
        />
        <img
          class="m4"
          v-if="item.display && item.display.indexOf('image') > -1"
          :src="item.image"
          style="object-fit: cover"
        />
        {{
          !item.display || item.display.indexOf("text") > -1 ? item.name : ""
        }}
      </a>
      <span v-if="item.type == 'component'" style="position: relative">
        <span
          class="flex align-center"
          @click="
            !$store.state.show.menus[name]
              ? (($store.state.show.menus[name] = {}),
                $store.commit('set', {
                  keys: ['show', 'menus', name, item.name],
                  val: true,
                }))
              : $store.state.show.menus[name][item.name]
              ? $store.commit('set', { keys: ['show', 'menus', name], val: {} })
              : (($store.state.show.menus[name] = {}),
                $store.commit('set', {
                  keys: ['show', 'menus', name, item.name],
                  val: !$store.state.show.menus[name][item.name],
                }))
          "
        >
          <i
            v-if="item.display && item.display.indexOf('icon') > -1"
            :class="item.icon"
          />
          <img
            class="m4"
            v-if="item.display && item.display.indexOf('image') > -1"
            :src="item.image"
            style="object-fit: contain"
          />
          {{
            !item.display || item.display.indexOf("text") > -1 ? item.name : ""
          }}
        </span>
        <div
          style="position: absolute; z-index: 999999999; display: flex"
          v-if="
            $store.state.show.menus[name] &&
            $store.state.show.menus[name][item.name]
          "
          :class="item.class"
        >
          <component
            :id="'inav_' + name.norm() + '_' + item.component.name.norm()"
            :class="'inav_' + name.norm() + '_' + item.component.name.norm()"
            style="position: relative; z-index: 999999999"
            v-bind="item.component.props"
            :is="item.component.name"
          />
        </div>
      </span>
      <span v-if="item.type == 'subnav'" style="position: relative">
        <span
          class="flex align-center"
          @click="
            !$store.state.show.menus[name]
              ? (($store.state.show.menus[name] = {}),
                $store.commit('set', {
                  keys: ['show', 'menus', name, item.name],
                  val: true,
                }))
              : $store.state.show.menus[name][item.name]
              ? $store.commit('set', { keys: ['show', 'menus', name], val: {} })
              : (($store.state.show.menus[name] = {}),
                $store.commit('set', {
                  keys: ['show', 'menus', name, item.name],
                  val: !$store.state.show.menus[name][item.name],
                }))
          "
        >
          <i
            v-if="item.display && item.display.indexOf('icon') > -1"
            :class="item.icon"
          />
          <img
            class="m4"
            v-if="item.display && item.display.indexOf('image') > -1"
            :src="item.image"
            style="object-fit: contain"
          />
          {{
            !item.display || item.display.indexOf("text") > -1 ? item.name : ""
          }}
        </span>
        <div
          style="position: absolute; z-index: 999999999; display: flex"
          v-if="
            $store.state.show.menus[name] &&
            $store.state.show.menus[name][item.name]
          "
          class="container fit max"
          @click="
            $store.commit('set', {
              keys: ['show', 'menus', name, item.name],
              val: !$store.state.show.menus[name][item.name],
            })
          "
        >
          <component
            :id="'inav_inav_' + item.menu.norm()"
            :class="'inav_inav_' + item.menu.norm()"
            style="position: relative; z-index: 999999999"
            class="sub-container"
            v-bind="{ name: item.menu, nohide: 'true' }"
            :is="'inav'"
          />
        </div>
      </span>
      <span
        class="flex align-center"
        v-if="item.type == 'action'"
        @click="$store.dispatch(item.do, JSON.parse(item.payload))"
      >
        <i
          v-if="item.display && item.display.indexOf('icon') > -1"
          :class="item.icon"
        />
        <img
          class="m4"
          v-if="item.display && item.display.indexOf('image') > -1"
          :src="item.image"
          style="object-fit: contain"
        />
        {{
          !item.display || item.display.indexOf("text") > -1 ? item.name : ""
        }}
      </span>
      <span
        class="flex align-center"
        v-if="item.type == 'mutation'"
        @click="$store.commit(item.do, JSON.parse(item.payload))"
      >
        <i
          v-if="item.display && item.display.indexOf('icon') > -1"
          :class="item.icon"
        />
        <img
          class="m4"
          v-if="item.display && item.display.indexOf('image') > -1"
          :src="item.image"
          style="object-fit: contain"
        />
        {{
          !item.display || item.display.indexOf("text") > -1 ? item.name : ""
        }}
      </span>
    </span>
    <i
      v-if="
        $refs[name + 'ref'] && $refs[name + 'ref'].clientWidth < 540 && this.$store.state.app.basics.menus[this.name].links.length > 1 && !nohide
      "
      class="fa fa-bars"
      :class="show[name + 'ref'] ? 'fa-rotate-90' : ''"
      @click="
        $set(show, name + 'ref', !show[name + 'ref']);
        updateref($refs[name + 'ref']);
      "
    ></i>
  </div>
</template>
<script>
export default {
  name: "inav",
  props: {
    name: { type: String },
    nohide: { type: [String, Boolean] },
  },
  mounted() {
    this.$set(this, "refs", this.$refs[this.name + "ref"]);
  },
  data() {
    return {
      computedmenu: [],
      refs: {},
      moduleLinks: [
        // []
        [
          "cart",
          "cart",
          "fas fa-shopping-cart",
          "fn",
          () => {
            this.$set(
              this.$store.state.show,
              "cart",
              !this.$store.state.show.cart
            );
          },
          "auth",
        ],
        [
          "jobs",
          "jobs",
          "fas fa-briefcase",
          "fn",
          () => {
            this.$set(
              this.$store.state.show,
              "jobs",
              !this.$store.state.show.jobs
            );
          },
          "auth",
        ],
        [
          "events",
          "events",
          "fas fa-calendar",
          "fn",
          () => {
            this.$set(
              this.$store.state.show,
              "events",
              !this.$store.state.show.events
            );
          },
          "auth",
        ],
      ],
      comLinks: [
        [
          "messages",
          "",
          " fa-envelope",
          "fn",
          () => {
            this.$set(
              this.$store.state.show,
              "messages",
              !this.$store.state.show.messages
            );
          },
          "auth",
          ["far", "fas"],
          "update",
        ],
        [
          "notifications",
          "",
          " fa-bell",
          "fn",
          () => {
            this.$set(
              this.$store.state.show,
              "notifications",
              !this.$store.state.show.notifications
            );
          },
          "any",
          ["far", "fas"],
          "indicate",
        ],
      ],
      show: {},
    };
  },
  created() {
    const hook =
      this.$store.state.app.basics.menus[this.name] &&
      this.$store.state.app.basics.menus[this.name].hook;
    // let name = hook && (hook.fun ? hook.fun.name : hook.get ? hook.get.name : false);
    if (hook && hook.fun) {
      this.$store.dispatch("run", {
        from: "menu " + this.name,
        if: hook.if || [],
        fun: hook.fun,
        payload: hook.getpayload || hook.payload || {},
      });
    }
    this.$store.state.anon.cart = JSON.parse(localStorage.getItem("cart"));
  },
  methods: {
    updateref(val) {
      val = val || this.$refs[this.name + "ref"];
      let menu =
        val &&
        val.clientWidth &&
        val.clientWidth < 540 &&
        !this.show[this.name + "ref"] &&
        !this.nohide && this.$store.state.app.basics.menus[this.name]
          ? [this.$store.state.app.basics.menus[this.name].links[0]]
          : this.$store.state.app.basics.menus[this.name] && this.$store.state.app.basics.menus[this.name].links &&
            this.$store.state.app.basics.menus[this.name].links.filter(
              (x) => x.type.length > 0
            );
      return this.$set(this, "computedmenu", menu);
    },
    closeAll() {
      this.$set(this.$store.state.componentKeys, "navigation", 0);
      this.$set(this.$store.state, "pointer", {});
      this.$store.commit("closeAll", {except:['admin', 'profile']});
    },
  },
  watch: {
    "$store.state.windowWidth"() {
      this.updateref();
    },
    refs: {
      immediate: true,
      handler: function (val) {
        this.$set(this, "refs", val);
        this.updateref(val);
      },
    },
  },
};
</script>